<div class="col-xl">
    <div class="card-wrapper card-space">
        <div class="card card-bg">
            <div class="card-body">
                <div>
                    <div class="container">
                        <div class="row" style="justify-content: center">
                            <div class="col-12 col-lg-8">
                                <div class="card" style="margin-bottom: -80px">
                                    <h3 class="card-title h6">Avviso sui cookie</h3>
                                    <div class="form-check p-0 m-0">
                                        <input id="checkbox1" type="checkbox">
                                        <label style="font-size:14px;" for="checkbox1">Visualizza cookie</label>
                                    </div>
                                    <div class="card-body p-0">
                                        <div class="form-group">
                                            <textarea style="resize: none; font-size: 16px"
                                                id="exampleFormControlTextarea1" placeholder="Contenuto sui cookie"
                                                rows="4"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="justify-content: center">
                            <div class="col-12 col-lg-8">
                                <div class="card" style="margin-bottom: -80px">
                                    <h3 class="card-title h6">Termini e Condizioni</h3>
                                    <div class="form-check p-0 m-0">
                                        <input id="checkbox2" type="checkbox">
                                        <label style="font-size:14px;" for="checkbox2">Visualizza Termini e
                                            Condizioni</label>
                                    </div>
                                    <div class="card-body p-0">
                                        <div class="form-group">
                                            <textarea style="resize: none;font-size: 16px"
                                                id="exampleFormControlTextarea2"
                                                placeholder="Contenuto termini e condizioni" rows="4"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="justify-content: center">
                            <div class="col-12 col-lg-8">
                                <div class="card">
                                    <h3 class="card-title h6">Avviso Privacy Policy</h3>
                                    <div class="form-check p-0 m-0">
                                        <input id="checkbox3" type="checkbox">
                                        <label style="font-size:14px;" for="checkbox3">Visualizza Privacy policy</label>
                                    </div>
                                    <div class="card-body p-0">
                                        <div class="form-group">
                                            <textarea style="resize: none;font-size: 16px"
                                                id="exampleFormControlTextarea3" placeholder="Contenuto privacy policy"
                                                rows="4"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-lg-8">
                                <button type="button" class="btn btn-primary">
                                    Salva
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>